function getBrowserWindow() {
  return typeof window !== 'undefined' ? window : null
}

function normalizeVersion(value) {
  return String(value || '').replace(/_/g, '.').trim()
}

export function resolveWebDeviceType(win = getBrowserWindow()) {
  const width = Number(win?.innerWidth)
  if (!Number.isFinite(width) || width <= 0)
    return 'unknown'
  if (width < 768)
    return 'mobile'
  if (width < 1200)
    return 'tablet'
  return 'desktop'
}

export function resolveWebOsContext(win = getBrowserWindow()) {
  const navigatorInfo = win?.navigator || {}
  const userAgent = String(navigatorInfo.userAgent || '')
  const platform = String(
    navigatorInfo.userAgentData?.platform || navigatorInfo.platform || '',
  )
  const isIPadOs = /Mac/i.test(platform) && Number(navigatorInfo.maxTouchPoints) > 1

  const androidMatch = userAgent.match(/Android\s+([\d._]+)/i)
  if (androidMatch) {
    return { os_type: 'android', os_version: normalizeVersion(androidMatch[1]) }
  }

  const iosMatch = userAgent.match(/(?:CPU (?:iPhone )?OS|iPhone OS)\s+([\d_]+)/i)
  if (iosMatch || /iPhone|iPad|iPod/i.test(userAgent) || isIPadOs) {
    return { os_type: 'ios', os_version: normalizeVersion(iosMatch?.[1]) }
  }

  const windowsMatch = userAgent.match(/Windows NT\s+([\d.]+)/i)
  if (windowsMatch || /Win/i.test(platform)) {
    return { os_type: 'windows', os_version: normalizeVersion(windowsMatch?.[1]) }
  }

  const chromeOsMatch = userAgent.match(/CrOS\s+[^\s]+\s+([\d.]+)/i)
  if (chromeOsMatch || /CrOS/i.test(platform)) {
    return { os_type: 'chromeos', os_version: normalizeVersion(chromeOsMatch?.[1]) }
  }

  const macOsMatch = userAgent.match(/Mac OS X\s+([\d_]+)/i)
  if (macOsMatch || /Mac/i.test(platform)) {
    return { os_type: 'macos', os_version: normalizeVersion(macOsMatch?.[1]) }
  }

  if (/Linux/i.test(userAgent) || /Linux/i.test(platform)) {
    return { os_type: 'linux', os_version: '' }
  }

  return { os_type: 'other', os_version: '' }
}

export function getWebAnalyticsDeviceContext(win = getBrowserWindow()) {
  return {
    device_type: resolveWebDeviceType(win),
    ...resolveWebOsContext(win),
  }
}
